import React from 'react';
const rows = [{
  before: 'Serate e domeniche passate a cercare idee che non convincono mai.',
  after: '–90% del tempo. Sessioni pronte sul tuo tablet in soli 2 clic.',
  labelBefore: 'Pianificazione',
  labelAfter: 'Pianificazione'
}, {
  before: 'Insicurezza nel gestire clienti con patologie della colonna.',
  after: 'Fiducia totale. Protocolli clinici sicuri e specifici.',
  labelBefore: 'Sicurezza',
  labelAfter: 'Sicurezza'
}, {
  before: 'Lezioni meccaniche che annoiano le tue allieve più fedeli.',
  after: '+100% originalità. Progressioni logiche che motivano e sfidano.',
  labelBefore: 'Varietà',
  labelAfter: 'Varietà'
}, {
  before: 'Arrivi in studio mentalmente stanca di organizzare tutto.',
  after: 'Zero stress. Arrivi carica per connetterti davvero con le tue allieve.',
  labelBefore: 'Energia',
  labelAfter: 'Energia'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-49">
      <div className="max-w-5xl mx-auto" data-id="element-50">
        <div className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-6 tracking-tight" data-id="element-52">
            La Trasformazione
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-53">
            Da un'istruttrice esausta a una professionista ispirata. Ecco cosa
            cambia dalla prima settimana con il Pilates Elite Bundle tra le tue
            mani.
          </p>
        </div>

        {/* Time cost callout */}
        <div className="bg-white border border-border-light rounded-2xl p-6 sm:p-8 mb-12 text-center shadow-[0_4px_20px_rgba(201,137,155,0.05)]" data-id="element-54">
          <p className="text-text-main text-lg sm:text-2xl font-bold leading-relaxed" data-id="element-55">
            <span className="text-badge-red font-black block mb-2" data-id="element-56">
              150+ ORE RISPARMIATE ALL'ANNO
            </span>
            Il costo reale: pianificare manualmente ti sottrae da 3 a 5 ore a
            settimana. È l'equivalente di un mese intero di lavoro all'anno
            bruciato tra quaderni, schizzi e dubbi mentali.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgba(201,137,155,0.08)] border border-border-light overflow-hidden" data-id="element-57">
          {/* Header */}
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-border-light bg-bg-main" data-id="element-58">
            <div className="px-6 py-5 font-bold text-badge-red text-center md:text-left border-b md:border-b-0 md:border-r border-border-light tracking-wider text-sm" data-id="element-59">
              SENZA IL KIT (La routine attuale)
            </div>
            <div className="px-6 py-5 font-black text-primary text-center md:text-left tracking-wider text-sm" data-id="element-60">
              CON IL BUNDLE (Pilates Elite)
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-border-light" data-id="element-61">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 group hover:bg-bg-main/50 transition-colors" data-id="element-62">
                <div className="px-6 py-6 flex items-start gap-4 border-b md:border-b-0 md:border-r border-border-light bg-badge-red/5" data-id="element-63">
                  <div className="w-6 h-6 rounded-full bg-badge-red/10 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/20" data-id="element-64">
                    <span className="text-badge-red font-bold text-sm" data-id="element-65">✕</span>
                  </div>
                  <p className="text-text-sec font-medium" data-id="element-66">
                    <strong className="text-badge-red block mb-1" data-id="element-67">
                      {row.labelBefore}:
                    </strong>
                    {row.before}
                  </p>
                </div>
                <div className="px-6 py-6 flex items-start gap-4 bg-primary/5 relative overflow-hidden" data-id="element-68">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-69"></div>
                  <div className="w-6 h-6 rounded-full bg-check-green/10 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/20 relative z-10" data-id="element-70">
                    <span className="text-check-green font-bold text-sm" data-id="element-71">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-main font-medium relative z-10" data-id="element-72">
                    <strong className="text-primary block mb-1" data-id="element-73">
                      {row.labelAfter}:
                    </strong>
                    {row.after}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}